import { Navigate } from "react-router-dom";

export function RedirectIfAuthed({ user, children, to = "/home" }) {
  // If your AuthContext exposes a loading flag, gate on it to avoid flicker:
  // const { loading } = useAuth();
  // if (loading) return null; // or a tiny spinner

  if (user) {
    return <Navigate to={to} replace />;
  }
  return children;
}
